import i18n from "i18next";
import {initReactI18next} from "react-i18next";

import en from "./en.js";
import es from "./es.js";
import zh from "./zh.js";

const DEFAULT_LANG = "es";

i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: DEFAULT_LANG,
  returnObject: true,
  interpolation: {escapeValue: false},
  resources: {
    en: {translation: en},
    es: {translation: es},
    zh: {translation: zh},
  },
  detection: {
    order: ["navigator"],
  },
});

export default i18n;
